module.exports = __webpack_public_path__ + "static/media/tan-blob.a3ae18de.svg";